import img1 from "./estepona-1.jpg";
import img2 from "./estepona-2.jpg";
import img3 from "./estepona-3.jpg";
import img4 from "./estepona-4.jpg";
import img5 from "./estepona-5.jpg";
import img6 from "./estepona-6.jpg";
import img7 from "./estepona-7.jpg";
import img8 from "./estepona-8.jpg";
import img9 from "./estepona-9.jpg";
import img10 from "./estepona-10.jpg";
import img11 from "./estepona-11.jpg";
import img12 from "./estepona-12.jpg";
import img13 from "./estepona-13.jpg";
import img14 from "./estepona-14.jpg";
import img15 from "./estepona-15.jpg";
import img16 from "./estepona-16.jpg";
import img17 from "./estepona-17.jpg";
import img18 from "./estepona-18.jpg";
import img19 from "./estepona-19.jpg";
import img20 from "./estepona-20.jpg";
import img21 from "./estepona-21.jpg";
import img22 from "./estepona-22.jpg";
import img23 from "./estepona-23.jpg";
import img24 from "./estepona-24.jpg";
import img25 from "./estepona-25.jpg";
import img26 from "./estepona-26.jpg";
import img27 from "./estepona-27.jpg";
import img28 from "./estepona-28.jpg";
import img29 from "./estepona-29.jpg";
import img30 from "./estepona-30.jpg";
import img31 from "./estepona-31.jpg";
import img32 from "./estepona-32.jpg";
import img33 from "./estepona-33.jpg";
import img34 from "./estepona-34.jpg";
import img35 from "./estepona-35.jpg";
import img36 from "./estepona-36.jpg";
import img37 from "./estepona-37.jpg";
import fp3d from "./floorplan-3d.jpg";
import fp2d from "./floorplan-2d.jpg";

export const esteponaImages = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img28, img29, img30,
  img31, img32, img33, img34, img35, img36, img37,
];

export const esteponaFloorPlans = [
  { image: fp3d, label: "3D půdorys" },
  { image: fp2d, label: "2D půdorys" },
];
